/* eslint-disable */
// prettier-ignore

export const messages = {
  customer_administration_users: "Users",
  customer_administration_invite_user: "Invite user",
  customer_administration_invite: "Invite",
  customer_administration_profile_status: "Profile status",
  customer_administration_completed: "Completed",
  customer_administration_invited: "Invited",
  customer_administration_identifier: "Identifier",
  customer_administration_functions: "Functions",
  customer_administration_view_dashboard: "View dashboard",
  customer_administration_role: "Role",
  customer_administration_deactivate: "Deactivate",
  customer_administration_deactivated: "Deactivated",
  customer_administration_deactivate_modal_title: "Deactivate API Key",
  customer_administration_deactivate_modal_description: "Deactivation of an API Key can not be undone. <br>Do you really want to deactivate the API Key?",
  customer_administration_api_key_deactivated: "API Key successfully deactivated",
  customer_administration_new_api_key: "New API Key",
  customer_administration_download_api_key: "Download API Key",
  customer_administration_new_api_key_description: "API Keys enable external systems to communicate with GLOBAL CLIMATE API .<br>Should a new API key be created?",
  customer_administration_download_api_key_description: "A new API Key has been created. <br> Download the API Key and save it in a secure way. GLOBAL CLIMATE stores an encrypted version of the the key and is not able ro decrypt or recreate the information.<br>Attention: After creating the API key, please assign permissions in the 'CCF Privileges' tab.",
  customer_administration_invite_user_description: "If you invite a new user an email with registration link will be send to the user. Enter the E-Mail of the user:",
  customer_administration_what_roles_should_get_assigned: "What roles should get assigned to the user?",
  customer_administration_cant_edit_own_roles: "Users are not allowed to edit their own roles.",
  customer_administration_ccf_warning: "Attention: Assigning the CCF role only grants access to open the CCF application. By default, users will not see any data. To provide access, please configure the appropriate CCF privileges under the CCF Privileges tab.",
  customer_administration_view_users_and_api_keys: "View users, API keys, licenses, organisation units",
  customer_administration_view_and_create_support_tickets: "View and create support tickets",
  customer_administration_answer_surveys: "Answer surveys",
  customer_administration_answer_global_reporting_data_collection: "Provide data in Global Reporting data collection",
  customer_administration_ccf_access: "CCF Tool Access",
  customer_administration_pcf_access: "PCF Tool Access",
  customer_administration_sbt_access: "SBT Tool Access",
  customer_administration_esg_access: "ESG Tool Access",
  customer_administration_csrd_access: "CSRD Tool Access",
  customer_administration_lksg_access: "LkSG Tool Access",
  customer_administration_global_reporting_admin_access: "Global Reporting Admin Access",
  customer_administration_global_reporting_user_access: "Global Reporting User Access",
  customer_administration_view_csrd_tool: "CSRD-Tool read access",
  customer_administration_view_invite_and_edit_users: "View, invite and edit users",
  customer_administration_view_create_and_deactivate_api_keys: "View, create and deactivate API keys",
  customer_administration_view_and_manage_licenses: "View and order licenses",
  customer_administration_view_and_manage_organisation_units: "View and manage organisation units",
  customer_administration_view_create_and_edit_company_code: "View, create and edit company codes",
  customer_administration_view_and_edit_co2_database: "View and edit CO<sub>2</sub> Database",
  customer_administration_view_and_edit_suppliers_and_transport_routes: "View, create and edit Suppliers and Transport Routes",
  customer_administration_view_and_edit_co2_bookings: "View, create and edit Unit and Financials Bookings",
  customer_administration_view_and_edit_commuter_surveys: "View, create and edit Commuter Surveys",
  customer_administration_download_report: "Download Report",
  customer_administration_view_create_and_edit_assessments: "View, create and edit ESG-Ratings",
  customer_administration_view_and_edit_partners: "View and edit partners",
  customer_administration_share_assessments_with_partners: "Share ESG-Rating results with partners",
  customer_administration_company_details: "Company Details",
  customer_administration_account: "Account",
  customer_administration_account_details: "Account Details",
  customer_administration_ccf_privileges: "CCF Privileges",
  customer_administration_user: "User",
  customer_administration_license_required: "License required",
  customer_administration_licenses: "Licenses",
  customer_administration_license_package: "License Package",
  customer_administration_license_list: "Licenses",
  customer_administration_employees: "Employees",
  customer_administration_buy_license: "Buy License",
  customer_administration_license_status: "License Status",
  customer_administration_license_info: "License Info",
  customer_administration_license_costs: "License costs",
  customer_administration_plus_vat: "plus VAT",
  customer_administration_ordered_by: "Ordered By",
  customer_administration_invoice_status: "Invoice Status",
  customer_administration_ordered: "Ordered",
  customer_administration_active: "Active",
  customer_administration_void: "Void",
  customer_administration_download_invoice: "Download Invoice",
  customer_administration_open_payment_page: "Open Payment Page",
  customer_administration_open: "Open",
  customer_administration_paid: "Paid",
  customer_administration_the_license_includes: "The license includes",
  customer_administration_please_validate_billing_info: "Please validate and adapt the billing information",
  customer_administration_small: "Small",
  customer_administration_medium: "Medium",
  customer_administration_large: "Large",
  customer_administration_invoice_email: "Invoice Email",
  customer_administration_tax_id: "Tax ID",
  customer_administration_buy_license_description_1: "By continuing an invoice will be send to the provided email address.",
  customer_administration_buy_license_description_2: "You can either pay via our payment service provider Stripe (credit card) or by bank transfer. If you transfer the amount directly, the license will be unlocked as soon as your payment is booked.",
  customer_administration_thanks_for_ordering_license: "Thank you for ordering a 1 year license!",
  customer_administration_we_will_send_you_the_invoice: "We will send you the invoice to the given email ({0}), but you can also download it here.",
  customer_administration_payment_description: "If you pay via our payment service provider Stripe, we can activate your license immediately.",
  customer_administration_activating_license_after_payment: "If you transfer the amount directly to the bank account specified in the invoice, the license will be unlocked as soon as your payment is received.",
  customer_administration_pay_now: "Pay now",
  customer_administration_next: "Next",
  customer_administration_requested_at: "Order Date",
  customer_administration_validity_period: "Validity Period",
  customer_administration_invalid_vat_tax_id: "Invalid VAT Tax ID",
  customer_administration_invitation_language: "Invitation mail language",

  // organization
  customer_administration_organization_tags_title: "Tags",
  customer_administration_organization_tags_description: "Use tags to simplify the filtering and grouping of your organisational units. Examples of useful tags include industry, region, business unit, or any other relevant criteria that support clearer identification and more efficient management of your organisational units.",
  customer_administration_organization_tags_tag_name: "Tag Name",
  customer_administration_organization_tags_dialog_add_title: "Add Tag",
  customer_administration_organization_tags_dialog_edit_title: "Edit Tag",
  customer_administration_organization_node_name: "Name",
  customer_administration_organization_node_relations: "Subsidiary",
  customer_administration_organization_units: "Organization Units",
  customer_administration_organization_relation: "Subsidiary",
  customer_administration_organization_select_tag: "Select a tag",
  customer_administration_organization_tag_value: "Value",
  customer_administration_organization_relation_company: "Company",
  customer_administration_organization_relation_share: "Share",
  customer_administration_organization_relation_from: "From",
  customer_administration_organization_relation_until: "Until",
  customer_administration_organization_add_organization_unit: "Organization Unit",
  customer_administration_organization_edit_organization_unit: "Edit Organization Unit",
  customer_administration_organization_organization_unit_created: "Organization Unit successfully created",
  customer_administration_organization_organization_unit_updated: "Organization Unit successfully updated",
  customer_administration_organization_organization_unit_deleted: "Organization Unit successfully deleted",
  customer_administration_organization_units_subtitle: "The table below displays all organisational units within your organisation’s organigram, along with the relationships between them. These relationships can be versioned and tracked over time.",
  customer_administration_organization_relations: "Subsidiaries",
  customer_administration_tags_deleted: "Tag successfully deleted",
  customer_administration_tags_created: "Tag successfully created",
  customer_administration_tags_updated: "Tag successfully updated",
  customer_administration_organization_graph_title: "Organization Units Graph",
  customer_administration_organization_documentation: "Documentation",

  // users and privileges
  customer_administration_users_and_privileges_title: "Users and Privileges",
  customer_administration_users_and_privileges_description: "In the following table you can see all users which have access to CCF data. If you want to grant access for a user, click the + User button and configure at least one privilege.",
  customer_administration_users_and_privileges_name: "Name",
  customer_administration_users_and_privileges_email: "Email",
  customer_administration_users_and_privileges_privileges: "Privileges",
  customer_administration_users_and_privileges_organization_privileges: "Organization Privileges",
  customer_administration_users_and_privileges_resource_privileges: "Resource Privileges",
  customer_administration_users_and_privileges_user_selection: "User Selection",
  customer_administration_users_and_privileges_user_selection_description: "Please select a user you want to configure the privileges for.",
  customer_administration_users_and_privileges_select_user: "Select a user",
  customer_administration_users_and_privileges_set_privileges: "Set User Privileges",
  customer_administration_users_and_privileges_user: "User",
  customer_administration_users_and_privileges_company_privileges: "Company Privileges",
  customer_administration_users_and_privileges_detailed_privileges: "Organization Detailed Privileges",
  customer_administration_users_and_privileges_organization: "Organization",
  customer_administration_users_and_privileges_saved: "User privileges successfully saved",
  customer_administration_users_and_privileges_delete_confirmation: "Do you want to remove the user's CCF access?",
  customer_administration_users_and_privileges_deleted: "User access successfully removed",
  customer_administration_users_and_privileges_company_level: "Company",
  customer_administration_users_and_privileges_organization_level_short: "Organization",
  customer_administration_users_and_privileges_resource_level_short: "Resource",
  customer_administration_users_and_privileges_selection_title: "Select a user or API key",
  customer_administration_users_and_privileges_add_user_privileges: "Add privileges for user",
  customer_administration_users_and_privileges_add_api_key_privileges: "Add privileges for API key",
  customer_administration_users_and_privileges_api_key_selection: "API Key Selection",
  customer_administration_users_and_privileges_api_key_selection_description: "Please select an API key you want to configure the privileges for.",
  customer_administration_users_and_privileges_select_api_key: "Select an API key",
  customer_administration_users_and_privileges_select_organization: "Select an organization",
  customer_administration_users_and_privileges_api_keys: "API Keys",
  customer_administration_users_and_privileges_users: "Users",
  customer_administration_users_and_privileges_type: "Type",
};
